const img = "zyoicdtl4j";

export { img };
import "./organism.print.style.linaria.module.css";
//# sourceMappingURL=organism.print.style.js.map
